import {
  AvailableCategories,
  getTranslatedProductCategories,
  ProductCategoriesLink,
} from "components/Navbar/types"
import { PageLayout } from "components/PageLayout"
import { useAppDispatch, useAppSelector } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { BillingGate } from "components/BillingGate"
import { setProductsCategories, setProductsCategoriesLoading } from "store/product/productSlice"
import { selectUserInfo } from "store/user/userSlice"
import { usePrefetchViewer3DKeys } from "@/features/viewer-3d/api/useViewer3D"
import { usePrefetchTryOnKeys } from "@/features/try-on/api/useTryOnIntegration"
import { UserStatusTypes } from "types"

export const AuthorizedUserLayout: React.FC = () => {
  const navigate = useNavigate()
  const { username, groups, status: userStatus } = useAppSelector(selectUserInfo)
  usePrefetchViewer3DKeys()
  usePrefetchTryOnKeys()
  const isAdmin = groups.some((group) => group.trim().toLowerCase() === "admin")
  const productsCategories = useAppSelector((state) => state.products.productsCategories)
  const location = useLocation()
  const { t } = useTranslation()
  const [isCheckingAuth, setIsCheckingAuth] = useState(true)
  const dispatch = useAppDispatch()
  const isActivateAccountRoute = location.pathname === "/activate-account"

  useEffect(() => {
    if (!username) navigate("/login")
    else if (["/login"].includes(location.pathname))
      if (productsCategories.length > 0) navigate(productsCategories[0].to, { replace: true })
      else navigate(ProductCategoriesLink.MAKEUP, { replace: true })

    setIsCheckingAuth(false)
  }, [username, location.pathname, navigate, productsCategories])

  useEffect(() => {
    dispatch(setProductsCategoriesLoading(true))
    const translatedCategories = getTranslatedProductCategories(t)
    const categories = AvailableCategories.filter((category) => category.enabled).map(
      ({ name }) => ({
        id: name,
        name,
      })
    )

    dispatch(
      setProductsCategories(
        categories.map((category) => ({
          label: translatedCategories[category.name] || category.name,
          to: ProductCategoriesLink[category.name] || ProductCategoriesLink.MAKEUP,
        }))
      )
    )
    dispatch(setProductsCategoriesLoading(false))
  }, [dispatch, t])

  if (isCheckingAuth) return <div className="flex h-screen w-screen items-center justify-center" />

  const billingGateEnabled =
    Boolean(username) &&
    !isAdmin &&
    userStatus === UserStatusTypes.ACTIVE &&
    !isActivateAccountRoute

  return (
    <PageLayout>
      <BillingGate enabled={billingGateEnabled}>
        <Outlet />
      </BillingGate>
    </PageLayout>
  )
}
